import React from 'react';
import { IconChevronDown } from './ChatIcons';

export default function ChatScrollButton({ onClick }) {
  return (
    <button type="button" className="chatbox-scroll-btn" onClick={onClick} aria-label="Shko poshtë">
      <IconChevronDown />
    </button>
  );
}
